import { FormFieldsForm } from "components/Forms/FormFieldsForm/FormFieldsForm.tsx";
import { LocationSectionHeader } from "components/UI/LocationSectionHeader";
import { SectionContentWrapper } from "components/UI/SectionContentWrapper";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { PermissionEnum } from "types/enums.ts";
import { FormId } from "types/models.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";
import { getToolStructureUserHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout/structure/"
)({
    component: UserStructureStructurePage,
    staticData: {
        permissions: [PermissionEnum.ToolStructureUserStructure],
        showInSideMenu: false,
        label: "pages.tool.structure.user.structure.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.tool.structure.user.structure.title"),
        };
    },
});

function UserStructureStructurePage() {
    const { formStructureId } = Route.useParams();

    return (
        <TenantPage
            headerNavigationItems={getToolStructureUserHeaderItems}
            isEdit={true}
            saveFormId={FormId.FormFieldsForm}
        >
            <SectionContentWrapper withBackground>
                <LocationSectionHeader level={3} className="mt-3" />
                <FormFieldsForm key={formStructureId} formStructureId={formStructureId} />
            </SectionContentWrapper>
        </TenantPage>
    );
}
